/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "App Storeでダウンロード",
      "近隣のグループとリアルで会おう",
      "Hiveで新しい仲間とつながることができます。",
      "関心を共有する人たちと出会おう",
      "多種多様な興味や関心に沿ったHiveがあります。",
      "自分らしくいられる安全な空間",
      "公開Hiveと非公開Hiveから選択できます。",
      "始める",
      "多種多様な興味や関心に沿ったHiveがあります",
      "Bumble BFFのHiveで新しいグループと出会おう",
      "Hive​に​招待​され​ました",
      "Bumble BFFに、地域の新しいグループと出会える新機能「Hives」が登場！BumbleアプリでBFFのプロフィールを今すぐ作成しよう。",
      "Google Playで入手",
      "Cookieの管理",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "日"
            ],
            "singular": [
                  "日"
            ]
      },
      "hour": {
            "plural": [
                  "時間"
            ],
            "singular": [
                  "時間"
            ]
      },
      "minute": {
            "plural": [
                  "分"
            ],
            "singular": [
                  "分"
            ]
      },
      "month": {
            "plural": [
                  "ヶ月"
            ],
            "singular": [
                  "ヶ月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
